import { CountrySelector } from '@bridebook/web/app-basic/components/country-selector/country-selector';
import { NoSSR } from '@bridebook/ui';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import FooterBottom from './footer-bottom';
import FooterContainer from './footer-container';
import FooterTop from './footer-top';

const Footer = () => {
  const market = useMarket();

  return (
    <FooterContainer>
      <FooterTop market={market} />
      <NoSSR>
        <FooterBottom
          localeSelect={<CountrySelector direction="top" initialSelection={market} />}
        />
      </NoSSR>
    </FooterContainer>
  );
};

export default Footer;
